import { render, staticRenderFns } from "./specialLiveManage-import.vue?vue&type=template&id=f548c604&scoped=true&"
import script from "./specialLiveManage-import.vue?vue&type=script&lang=js&"
export * from "./specialLiveManage-import.vue?vue&type=script&lang=js&"
import style0 from "./specialLiveManage-import.vue?vue&type=style&index=0&id=f548c604&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f548c604",
  null
  
)

export default component.exports